export default __webpack_public_path__ + "static/media/eyeClosedIcon.108dfa4c.svg";